import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "../../../hooks/useSessionStorage";

export const useSettings = () => {
  const navigate = useNavigate();
  const [usuario] = useSessionStorage("@usuarioMapa");
  const isAdmin = usuario?.roles?.includes("ROLE_ADMIN");

  const canAccessStores =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_LOJA_VER");
  const canAccessDealerships =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_CONCESSIONARIA_VER");
  const canAccessHolidays =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_FERIADO_VER");
  const canAccessDeliveries =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_DELIVERY_VER");
  const canAccessMobileUnits =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_ITINERANTE_VER");
  const canAccessEmployees =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_COLABORADOR_VER");
  const canAccessClients =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_CLIENTE_VER");
  const canAccessProfiles =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_PERFIL_VER");

  return {
    navigate,
    canAccessStores,
    canAccessDealerships,
    canAccessHolidays,
    canAccessDeliveries,
    canAccessMobileUnits,
    canAccessEmployees,
    canAccessClients,
    canAccessProfiles,
  };
};
